// @flow
export const Roles = {
  User: 'ROLE_USER',
  Beneficiary: 'ROLE_BENEFICIARY',
  Admin: 'ROLE_ADMIN',
  Manager: 'ROLE_RD',
  Coach: 'ROLE_CP',
};
